import { render, staticRenderFns } from "./MyWriters.vue?vue&type=template&id=0bbfe513&"
import script from "./MyWriters.vue?vue&type=script&lang=js&"
export * from "./MyWriters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports